export default __webpack_public_path__ + "static/media/screen_livechat_08.7baaed88.png";